import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { AIConversation } from '../../extViewmodels/sdk/models/AI';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAIAssistantCreateConversationMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: AIConversation) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: {
			assistantName: string;
			impersonationContext?: Api.IImpersonationContext;
			phoneCallId?: string;
			companyId?: string;
			leadServedId?: string;
			source?: string;
		}) => {
			const { assistantName, impersonationContext, phoneCallId, companyId, leadServedId, source } = params;

			// Build query string parameters
			const queryParams = new URLSearchParams();
			if (phoneCallId) queryParams.append('phoneCallId', phoneCallId);
			if (companyId) queryParams.append('companyId', companyId);
			if (leadServedId) queryParams.append('leadServedId', leadServedId);
			if (source) queryParams.append('source', source);

			const queryString = queryParams.toString();
			const urlPath = `ai/assistant/${assistantName}/conversation${queryString ? `?${queryString}` : ''}`;

			return userSession.webServiceHelper.callAsync<AIConversation>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath,
					impersonationContext,
				}),
				'POST'
			);
		},
		onError,
		onSuccess,
	});
}
